import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const Dashboard = React.lazy(() => import("./Dashboard"));
const InvestorList = React.lazy(() => import("./InvestorList"));
const NewInvestor = React.lazy(() => import("./NewInvestor"));
const InvestorDetails = React.lazy(() => import("./InvestorDetails"));
const EditInvestor = React.lazy(() => import("./EditInvestor"));

const investorsModuleConfig: ModuleConfig = {
  id: "investors",
  name: "Investors",
  description: "Track migration visa applicants and sophisticated investors through the investment pipeline",
  version: "1.0.0",
  enabled: true,
  category: "investment",
  order: 1,
  icon: "💰",
  color: "#38A169",

  routes: [
    { path: "/investors", component: Dashboard, permissionLevel: "view" },
    { path: "/investors/list", component: InvestorList, permissionLevel: "view" },
    { path: "/investors/new", component: NewInvestor, permissionLevel: "create" },
    { path: "/investors/:id", component: InvestorDetails, permissionLevel: "view" },
    { path: "/investors/:id/edit", component: EditInvestor, permissionLevel: "edit" },
  ],

  navigation: [
    { label: "Dashboard", path: "/investors", icon: "📊", permissionLevel: "view" },
    { label: "All Investors", path: "/investors/list", icon: "📋", permissionLevel: "view" },
    { label: "New Investor", path: "/investors/new", icon: "➕", permissionLevel: "create" },
  ],

  permissions: {
    view: [],
    create: [],
    edit: [],
    delete: [],
  },

  quickActions: [
    {
      label: "Register Investor",
      path: "/investors/new",
      icon: "➕",
      description: "Register a new visa applicant or investor",
    },
  ],

  changelog: [
    {
      version: "1.0.0",
      releaseDate: "2026-02-26",
      title: "Initial Release - Investor Pipeline Tracker",
      features: [
        "Investor registration with full profile",
        "Pipeline dashboard with stage counts",
        "Migration visa and sophisticated investor types",
        "AML/source of funds compliance tracking",
        "Document upload and verification",
        "Activity notes timeline",
        "Filterable investor list",
      ],
      notes: "MVP release for Vanguard IQ visa investment platform.",
    },
  ],

  roadmap: [],
};

export default investorsModuleConfig;
